import React, { Suspense, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, Route, Routes, useParams } from "react-router-dom";
import { GetClassroom } from "../../../store/ClassroomAdmin/ClassroomAdminClassroomAction";
import NotFound from '../../../components/administration/components/NotFound';
import { RootState } from '../../../store/store';
import { RequestState } from '../../../models/RequestState';
import { CoreClassroomAdminClassroom } from '../../../models/CoreClassroomAdminClassroom';
import * as Tab from '../../../util/TabValue';
import RenderTabs from '../../misc/Tabs';
import StatusCode from "../../../util/StatusCode";
import Loading from "../../misc/Loading";
import ClassroomViewInfo from "./ClassroomViewInfo";
import ClassroomViewObjectLogs from "./ClassroomViewObjectLogs";
import ClassroomViewTrackings from "./ClassroomViewTrackings";
import ClassroomViewTools from "./ClassroomViewTools";


const ClassroomView = () => {
    const { t } = useTranslation(['common', "classroomAdmin"]);

    const { classroomId } = useParams();
    const dispatch = useDispatch();
    const classroom = useSelector<RootState, RequestState<CoreClassroomAdminClassroom>>(x => x.classroomAdminClassroom.classroom);

    useEffect(() => {
        if (classroomId) {
            GetClassroom(classroomId)(dispatch);
        }
    }, [dispatch]);

    const tabs = [
        Tab.Tabs.Information,
        Tab.Tabs.ObjectLogs,
        Tab.Tabs.Trackings,
        Tab.Tabs.Tools,
    ];

    if (classroomId === undefined) {
        return;
    }

    let displayName: string | undefined = '';

    const renderContent = (body: any) => (
        <div className="padding-40 container single">
            <h1><Link to="/classroomadmin/classroom">{t('object.classroomAdmin.classroom', { ns: 'common' })}</Link> {displayName}</h1>
            {body}
        </div>
    )

    switch (classroom.code) {
        case StatusCode.COMPLETE:
            displayName = classroom.data.classroomName;
            return (renderContent(<>
                <RenderTabs
                    tabs={tabs}
                    id={classroomId}
                    url="classroomadmin/classroom" />

                <Suspense fallback={<Loading />}>
                    <Routes>
                        <Route path={Tab.Tabs.Information.url} element={<ClassroomViewInfo />} />
                        <Route path={Tab.Tabs.ObjectLogs.url} element={<ClassroomViewObjectLogs />} />
                        <Route path={Tab.Tabs.Trackings.url} element={<ClassroomViewTrackings />} />
                        <Route path={Tab.Tabs.Tools.url} element={<ClassroomViewTools />} />
                        <Route path="*" element={<Navigate replace={true} to={`/classroomadmin/classroom/${classroomId}/${Tab.Tabs.Information.url}`} />} />
                    </Routes>
                </Suspense>
            </>))
        case StatusCode.ERROR:
            if (classroom.error.response?.status === 404 || classroom.error.response?.status === 400) {
                return (
                    <NotFound
                        header={t('object.classroomAdmin.classroom', { ns: 'common' })}
                        translateKey={{ i18nKey: "classroomAdmin.notFound.classroom", ns: "classroomAdmin" }}
                        link="/classroomadmin/classroom"
                    />
                );
            } else {
                return renderContent(<p>{classroom.error.response?.statusText}</p >);
            }
        default:
            return (renderContent(<Loading />));
    }
}

export default ClassroomView;
